const BELGIAN_POSTCODE_LENGTH = 4;
const DUTCH_POSTCODE_LENGTH = 6;
const BELGIAN_POSTCODE_ZOOM = 16;
const DUTCH_POSTCODE_ZOOM = 14;
const DEFAULT_ZOOM = 7;

export default function getZoom(postcode?: string): number {
  if (!postcode) {
    return DEFAULT_ZOOM;
  }

  if (postcode.length === BELGIAN_POSTCODE_LENGTH) {
    return BELGIAN_POSTCODE_ZOOM;
  }

  if (postcode.length === DUTCH_POSTCODE_LENGTH) {
    return DUTCH_POSTCODE_ZOOM;
  }

  return DEFAULT_ZOOM;
}
